export default __webpack_public_path__ + "static/media/keto_bad_fats@3x.27021c5a.jpg";